import React, {useEffect, useState} from "react";
import {withRouter} from 'react-router-dom';
import './tutorDetails.scss';
import PersonalDetailsCard from "../../../shared/components/PersonalDetailsCard";
import TutorExpertise from "./TutorExpertise";
import TutorLiveClasses from "./TutorLiveClasses";
import TutorService from "../../../services/TutorService/tutor.service";
import {TutorModel} from "../../../models/TutorModel/tutor.model";
import TutorForm from "../TutorForm";
import DeleteAlert from "../../../shared/components/DeleteAlert";
import avatarPlaceholder from "../../../assets/placeholder/avatar_placeholder.png";

const TutorDetails = (props:any) => {

    useEffect(()=>{
        fetchTutorDetails()
    },[props]);

    const fetchTutorDetails = () =>{
        const {tutorId} = props.match.params;

        TutorService.getTutorDetails(tutorId,
            (tutor:any)=>{
                tutor.expertise = tutor.classroomSubjects;
                setTutor(tutor)
            },
            ()=>{},
            ()=>{},
        ).then()
    }

    const handleDelete = () => {
        TutorService.deleteTutor(tutor.id,
            ()=>{
                props.history.goBack()
            },
            ()=>{},
            ()=>{},
        ).then()
    }

    const [tutor,setTutor] = useState<any>();
    const [showForm,setShowForm] = useState<boolean>(false);
    const [deleteVisible,setDeleteVisible] = useState<boolean>(false);

    return(
        <div className='page-view'>
            <TutorForm title={'Edit tutor'}
                       visible={showForm}
                       setVisible={setShowForm}
                       data={tutor}
                       refreshList={fetchTutorDetails}
            />
            <DeleteAlert visible={deleteVisible}
                         setVisible={setDeleteVisible}
                         deleteText={'tutor'}
                         contentTitle={tutor?.fullName}
                         logo={tutor?.displayPictureUrl || avatarPlaceholder}
                         detail={'Tutor'}
                         handleDelete={handleDelete}
            />
            <PersonalDetailsCard data={tutor}
                                 handleEdit={setShowForm}
                                 handleDelete={setDeleteVisible}
                                 type={'tutor'}
            />
            <TutorExpertise />
            <TutorLiveClasses />
        </div>
    )
}

export default withRouter(TutorDetails);
